export const RECORD_REPLY_SOURCE_ENGAGEMENT_BAR = 'engagement bar';
export const RECORD_REPLY_SOURCE_VIDEO_END_SCREEN = 'video end screen';
export const RECORD_REPLY_SOURCE_COMMENT_BAR = 'comment bar';
